// src/components/candles/CandleSVG.js
import React from 'react';

const gradId = (color) => `grad_${color.replace(/[^a-z0-9]/gi, '')}`;

function Heart({ color, size }) {
  const id = gradId(color + 'h');
  return (
    <svg width={size} height={size} viewBox="0 0 120 120">
      <defs>
        <radialGradient id={id} cx="50%" cy="40%">
          <stop offset="0%" stopColor="#fff" stopOpacity="0.55" />
          <stop offset="100%" stopColor={color} />
        </radialGradient>
      </defs>
      <path
        d="M60 100 C20 70 10 40 30 25 C45 15 60 30 60 30 C60 30 75 15 90 25 C110 40 100 70 60 100Z"
        fill={`url(#${id})`}
        stroke="rgba(255,255,255,0.2)"
        strokeWidth="0.5"
      />
      <circle cx="43" cy="48" r="8" fill="white" fillOpacity="0.35" />
      <circle cx="66" cy="42" r="5.5" fill="white" fillOpacity="0.22" />
      <line x1="60" y1="19" x2="60" y2="9" stroke="#fbbf24" strokeWidth="1.5" strokeLinecap="round" />
      <ellipse cx="60" cy="8" rx="3" ry="5.5" fill="#fde68a" />
    </svg>
  );
}

function Rose({ color, size }) {
  const id = gradId(color + 'r');
  return (
    <svg width={size} height={size} viewBox="0 0 120 120">
      <defs>
        <radialGradient id={id} cx="50%" cy="38%">
          <stop offset="0%" stopColor="#fff" stopOpacity="0.5" />
          <stop offset="100%" stopColor={color} />
        </radialGradient>
      </defs>
      <ellipse cx="60" cy="73" rx="30" ry="33" fill={`url(#${id})`} />
      <path d="M60 44 C49 54 44 65 49 75 C54 85 66 85 71 75 C76 65 71 54 60 44Z" fill={color} opacity="0.85" />
      <path d="M60 49 C54 57 51 65 54 72 C57 79 65 79 68 72 C70 65 66 57 60 49Z" fill="white" fillOpacity="0.38" />
      <line x1="60" y1="37" x2="60" y2="27" stroke="#fbbf24" strokeWidth="1.5" strokeLinecap="round" />
      <ellipse cx="60" cy="26" rx="3" ry="5.5" fill="#ffd700" />
    </svg>
  );
}

function Bubble({ color, size }) {
  const positions = [
    [25,30],[50,30],[75,30],
    [25,55],[50,55],[75,55],
    [25,80],[50,80],[75,80],
  ];
  return (
    <svg width={size} height={size} viewBox="0 0 120 120">
      {positions.map(([cx, cy], i) => (
        <g key={i}>
          <circle cx={cx} cy={cy} r="12" fill={color} opacity="0.85" />
          <circle cx={cx - 4} cy={cy - 4} r="4.5" fill="white" fillOpacity="0.42" />
        </g>
      ))}
      <line x1="60" y1="14" x2="60" y2="4" stroke="#fbbf24" strokeWidth="1.5" strokeLinecap="round" />
      <ellipse cx="60" cy="3" rx="3" ry="5" fill="#ffd700" />
    </svg>
  );
}

function Circle({ color, size }) {
  const id = gradId(color + 'c');
  return (
    <svg width={size} height={size} viewBox="0 0 120 120">
      <defs>
        <radialGradient id={id} cx="40%" cy="35%">
          <stop offset="0%" stopColor="#fff" stopOpacity="0.5" />
          <stop offset="100%" stopColor={color} />
        </radialGradient>
      </defs>
      <circle cx="60" cy="68" r="40" fill={`url(#${id})`} />
      <circle cx="44" cy="56" r="11" fill="white" fillOpacity="0.38" />
      <circle cx="66" cy="50" r="7.5" fill="white" fillOpacity="0.25" />
      <line x1="60" y1="25" x2="60" y2="15" stroke="#fbbf24" strokeWidth="1.5" strokeLinecap="round" />
      <ellipse cx="60" cy="14" rx="3" ry="5.5" fill="#ffd700" />
    </svg>
  );
}

function Gift({ color, size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120">
      <rect x="22" y="50" width="76" height="58" rx="4" fill={color} opacity="0.9" />
      <rect x="18" y="37" width="84" height="18" rx="3" fill={color} opacity="0.65" />
      <rect x="51" y="37" width="18" height="71" fill="white" fillOpacity="0.38" />
      <path d="M60 37 C38 37 33 23 44 20 C55 17 60 37 60 37Z" fill="#f9a8c9" />
      <path d="M60 37 C82 37 87 23 76 20 C65 17 60 37 60 37Z" fill="#f9a8c9" />
      <circle cx="46" cy="76" r="5" fill="white" fillOpacity="0.45" />
    </svg>
  );
}

function Cube({ color, size }) {
  const positions = [[28,30],[60,30],[28,62],[60,62]];
  return (
    <svg width={size} height={size} viewBox="0 0 120 120">
      {positions.map(([x, y], i) => (
        <g key={i}>
          <rect x={x - 13} y={y - 13} width="26" height="26" rx="9" fill={color} opacity="0.88" />
          <circle cx={x - 5} cy={y - 5} r="5" fill="white" fillOpacity="0.38" />
        </g>
      ))}
      <line x1="60" y1="12" x2="60" y2="3" stroke="#fbbf24" strokeWidth="1.5" strokeLinecap="round" />
      <ellipse cx="60" cy="2" rx="2.8" ry="4.5" fill="#ffd700" />
    </svg>
  );
}

function Tulip({ color, size }) {
  const id = gradId(color + 't');
  return (
    <svg width={size} height={size} viewBox="0 0 120 120">
      <defs>
        <radialGradient id={id} cx="50%" cy="35%">
          <stop offset="0%" stopColor="#fff" stopOpacity="0.5" />
          <stop offset="100%" stopColor={color} />
        </radialGradient>
      </defs>
      <path d="M60 90 C35 80 25 55 30 35 C40 20 60 18 60 18 C60 18 80 20 90 35 C95 55 85 80 60 90Z" fill={`url(#${id})`} />
      <ellipse cx="48" cy="52" rx="8" ry="12" fill="white" fillOpacity="0.28" />
      <line x1="60" y1="17" x2="60" y2="7" stroke="#fbbf24" strokeWidth="1.5" strokeLinecap="round" />
      <ellipse cx="60" cy="6" rx="3" ry="5" fill="#ffd700" />
    </svg>
  );
}

function Daisy({ color, size }) {
  const petals = [0, 45, 90, 135, 180, 225, 270, 315];
  return (
    <svg width={size} height={size} viewBox="0 0 120 120">
      {petals.map((angle, i) => {
        const rad = (angle * Math.PI) / 180;
        const cx = 60 + Math.cos(rad) * 26;
        const cy = 60 + Math.sin(rad) * 26;
        return <ellipse key={i} cx={cx} cy={cy} rx="9" ry="15"
          fill={color} opacity="0.82"
          transform={`rotate(${angle}, ${cx}, ${cy})`} />;
      })}
      <circle cx="60" cy="60" r="16" fill="#fde68a" />
      <circle cx="55" cy="55" r="5" fill="white" fillOpacity="0.5" />
      <line x1="60" y1="12" x2="60" y2="3" stroke="#fbbf24" strokeWidth="1.5" strokeLinecap="round" />
      <ellipse cx="60" cy="2" rx="2.8" ry="4.5" fill="#ffd700" />
    </svg>
  );
}

const SHAPE_MAP = {
  heart: Heart,
  rose: Rose,
  bubble: Bubble,
  circle: Circle,
  gift: Gift,
  cube: Cube,
  tulip: Tulip,
  daisy: Daisy,
};

export default function CandleSVG({ shape = 'heart', color = '#f9a8c9', size = 100 }) {
  const Component = SHAPE_MAP[shape] || Circle;
  return <Component color={color} size={size} />;
}
